// avstemming-period-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'avhp.common.countOf': '{done} av {total}',
  'avhp.common.summary': '{done} av {total} behandlet · {passed} bestått · {deviations} avvik',
  'avhp.common.conclusion': 'Konklusjon',
  'avhp.common.cancel': 'Avbryt',
  'avhp.common.open': 'Åpne',
  'avhp.common.hidePassed': 'Skjul beståtte',
  'avhp.common.hide': 'Skjul',
  'avhp.common.responsible': 'Ansvarlig',
  'avhp.common.status': 'Status',
  'avhp.common.area': 'Område',
  'avhp.common.amount': 'Beløp',
  'avhp.common.deadline': 'Frist',
  'avhp.common.type': 'Type',
  'avhp.common.notAvailable': 'Ikke tilgjengelig',
  'avhp.common.sec.crossChecks': 'Tverrkontroller',
  'avhp.common.sec.analytics': 'Analytisk kontroll',
  'avhp.common.sec.tasks': 'Oppgaver og avvik',
  'avhp.common.sec.reporting': 'Rapportering',
  'avhp.common.sec.areas': 'Avstemmingsområder',
  'avhp.common.sec.checklist': 'Sjekkliste',
  'avhp.common.sum.areasWithDeviation': 'Områder med avvik',
  'avhp.common.sum.accountsNoDocs': 'Kontoer uten dokumentasjon',
  'avhp.common.sum.openItems': 'Åpne avstemmingsposter',
  'avhp.common.sum.activeTasks': 'Aktive oppgaver',
  'avhp.common.sum.unexplainedAnalytics': 'Analytiske avvik uten forklaring',
  'avhp.common.professionalChecklist': 'Faglig sjekkliste',
  'avhp.common.issues.one': '{count} forhold',
  'avhp.common.issues.other': '{count} forhold',
  'avhp.cp.notAssessed': 'Ikke vurdert',
  'avhp.cp.ok': 'OK',
  'avhp.cp.remark': 'Merknad',
  'avhp.cp.mustFix': 'Må rettes',
  'avhp.ck.source': 'Kilde og evidens: {source}',
  'avhp.ck.critical': 'Kritisk',
  'avhp.ck.rationaleRequired': 'Begrunnelse kreves',
  'avhp.ck.rationale': 'Begrunnelse',
  'avhp.ck.deviationPlaceholder': 'Hva er avviket, og hva gjøres med det?',
  'avhp.ck.waiting': ' · {count} venter',
  'avhp.ck.blocked': ' · {count} blokkert',
  'avhp.ck.controller': 'Kontrollør',
  'avhp.ck.reviewerPointsDone': '{done} av {total} kontrollørpunkter behandlet',
  'avhp.ck.reviewerNote': 'Punktene besvares i kontrollfanen i høyrepanelet, av en annen enn den som utførte arbeidet.',
  'avhp.ck.reviewerLocked': 'Tilgjengelig etter innsending til kontroll. Kontrollørens punkter kan ikke behandles mens perioden fortsatt er under arbeid hos utfører.',
  'avhp.cl.title': 'Konklusjon og godkjenning',
  'avhp.cl.areasDone': 'Avstemmingsområder ferdig',
  'avhp.cl.untreatedPoints': 'Ubehandlede kontrollpunkter',
  'avhp.cl.overallStatus': 'Samlet status',
  'avhp.cl.approvedLocked': 'Godkjent og låst',
  'avhp.cl.ready': 'Klar til kontroll',
  'avhp.cl.notReady': 'Ikke klar til kontroll',
  'avhp.cl.openArea': 'Åpne område',
  'avhp.cl.conclusionHint': 'En periode uten et ord om hva som ble gjort er ikke gjennomgått — den er bare åpnet.',
  'avhp.cl.remainingRisk': 'Gjenstående risiko',
  'avhp.cl.followUpNext': 'Oppfølging neste periode',
  'avhp.cl.performedBy': 'Utført av',
  'avhp.cl.checkedBy': 'Kontrollert av',
  'avhp.cl.saveConclusion': 'Lagre konklusjon',
  'avhp.cl.sendTitle': 'Sender hele perioden til kontroll hos en annen enn deg.',
  'avhp.cl.sendTitleBlockedOne': 'Perioden kan sendes til kontroll, men {count} forhold står fortsatt igjen.',
  'avhp.cl.sendTitleBlockedMany': 'Perioden kan sendes til kontroll, men {count} forhold står fortsatt igjen.',
  'avhp.cl.sendToReview': 'Send til kontroll',
  'avhp.cl.approvalNote': 'Godkjenningen gjøres av kontrolløren i kontrollfanen — ikke herfra.',
  'avhp.cl.lastSaved': 'Sist lagret {date}',
  'avhp.cl.savedBy': ' av {email}',
  'avhp.cl.periodLock': 'Periodelås',
  'avhp.cl.lockNote': 'Låsing begrenser endringer i perioden. Gjenåpning krever en begrunnelse, og den blir stående i aktivitetsloggen.',
  'avhp.cl.reopenPeriod': 'Gjenåpne perioden',
  'avhp.cl.lockPeriod': 'Lås perioden',
  'avhp.sec.crossChecksNote': 'Kontroller som går på tvers av flere avstemmingsområder.',
  'avhp.sec.showPassed': 'Vis {count} beståtte',
  'avhp.sec.controlRule': 'Kontrollregel',
  'avhp.sec.dataSources': 'Datakilder',
  'avhp.sec.result': 'Resultat',
  'avhp.sec.deviation': 'Avvik',
  'avhp.sec.outcome': 'Utfall',
  'avhp.sec.confirm': 'Bekreft',
  'avhp.sec.confirmedBy': 'Bekreftet av {name}',
  'avhp.sec.completeness': 'Fullstendighet og riktig periode',
  'avhp.sec.completenessNote': 'Plumme foreslår hvilke poster som bør vurderes, men konkluderer ikke automatisk med at de er feil. Radene som står som «ikke tilgjengelig» har Plumme ingen kilde til ennå — de er ikke kontrollert til null.',
  'avhp.sec.noBasisData': 'Datagrunnlag mangler for denne sammenlikningen',
  'avhp.sec.analyticsNote': 'Tallene er hentet fra saldobalansen. Om et avvik er vesentlig avgjøres av beløp, vesentlighetsgrense, historisk variasjon og kjent forklaring sammen — ikke av prosenten alene, og ikke av Plumme.',
  'avhp.sec.thisPeriod': 'Denne perioden',
  'avhp.sec.comparison': 'Sammenligning',
  'avhp.sec.deviationKr': 'Avvik (kr)',
  'avhp.sec.deviationPct': 'Avvik (%)',
  'avhp.sec.explanation': 'Forklaring',
  'avhp.sec.grossProfit': 'Bruttofortjeneste / -margin',
  'avhp.sec.marginNote': 'Omsetning og varekostnad bør vurderes sammen — marginen kan falle selv om bruttofortjenesten øker i kroner.',
  'avhp.sec.notExplained': 'Ikke forklart',
  'avhp.sec.editExplanation': 'Endre forklaring',
  'avhp.sec.registerExplanation': 'Registrer forklaring',
  'avhp.sec.explanationHint': 'Kreves. En sammenlikning uten et ord om hvorfor er ikke en vurdering.',
  'avhp.sec.documentationOptional': 'Dokumentasjon (valgfritt)',
  'avhp.sec.voucherPlaceholder': 'Bilagsnummer eller notat',
  'avhp.sec.actionFollowUp': 'Tiltak / oppfølging neste periode',
  'avhp.sec.saveExplanation': 'Lagre forklaring',
  'avhp.sec.noResultLines': 'Ingen resultatlinjer i perioden å sammenlikne. Er det ikke bokført inntekter eller kostnader ennå, finnes det ingen utvikling å analysere.',
  'avhp.sec.tasksNote': 'En oppgave er et tiltak på én avstemmingspost i et fagområde — ikke en kopi av den. Løses tiltaket, er det kildeposten som endrer seg, og oppgaven forsvinner herfra av seg selv.',
  'avhp.sec.priority': 'Prioritet',
  'avhp.sec.sourceAreaItem': 'Kildeområde / post',
  'avhp.sec.description': 'Beskrivelse',
  'avhp.sec.waitingForCustomer': 'Venter på kunde',
  'avhp.sec.markResolved': 'Marker løst',
  'avhp.sec.closedElsewhere': 'Lukkes der den hører hjemme',
  'avhp.sec.resultHint': 'Kreves for å markere oppgaven løst — teksten lagres på kildens avstemmingspost.',
  'avhp.sec.resolvedBy': 'Løst av',
  'avhp.sec.confirmResolved': 'Bekreft løst',
  'avhp.sec.noTasks': 'Ingen åpne tiltak i perioden. Oppgaver oppstår når noen skriver et tiltak på en avstemmingspost i et fagområde.',
  'avhp.sec.reportsNote': 'Frister vises bare der Plumme har en kilde til dem. En frist uten kilde ville sett like autoritativ ut som en som har det. Plumme sender ikke inn noe uten godkjenning.',
  'avhp.sec.reportObligation': 'Rapport / plikt',
  'avhp.sec.appliesToPeriod': 'Gjelder periode',
  'avhp.sec.dataBasis': 'Datagrunnlag',
  'avhp.sec.notRegistered': 'Ikke registrert',
  'avhp.pg.modelNotLoaded': 'Lesemodellen for periodekontroller er ikke lastet.',
  'avhp.pg.overview': 'Oversikt',
  'avhp.pg.unexplained': '{count} uforklart',
  'avhp.pg.explained': 'Forklart',
  'avhp.pg.activeCount': '{count} aktive',
  'avhp.pg.ready': 'Klar',
  'avhp.pg.blocked': 'Blokkert',
  'avhp.pg.noOwnBalance': 'ingen egen saldo — status hentes fra de andre områdene',
  'avhp.pg.title': 'Periodekontroller',
  'avhp.pg.dataThrough': ' · Datagrunnlag til og med {date}',
  'avhp.pg.responsible': ' · Ansvarlig {name}',
  'avhp.pg.materialityLabel': ' · Vesentlighetsgrense ',
  'avhp.pg.notSet': 'ikke satt',
  'avhp.pg.areaLimitsDiffer': ' (områdespesifikke grenser kan avvike)',
  'avhp.pg.dataVersionTitle': 'Alle statuser, summer og blokkeringer på denne siden leses av det samme regnskapet og de samme avstemmingene.',
  'avhp.pg.basisLine': 'Grunnlag: saldobalansen og avstemmingene slik de står nå',
  'avhp.pg.areasProcessed': '{done} av {total} relevante områder er ferdig behandlet.',
  'avhp.pg.blockersOne': '{count} forhold blokkerer ferdigstilling av perioden.',
  'avhp.pg.blockersMany': '{count} forhold blokkerer ferdigstilling av perioden.',
  'avhp.pg.noBlockers': 'Ingenting blokkerer ferdigstilling av perioden.',
  'avhp.pg.preliminary': '{period} er ikke avsluttet. Dette er en foreløpig periodekontroll per {date} — endelig hovedbok og integrasjonsdata må leses på nytt etter periodeslutt.',
  'avhp.pg.overallOverview': 'Overordnet periodeoversikt',
  'avhp.pg.kpiRelevant': 'Relevante avstemmingsområder',
  'avhp.pg.kpiDone': 'Ferdig behandlet',
  'avhp.pg.hintOpenItems': 'Et identifisert forhold i et avstemmingsområde. Ikke det samme som en oppgave.',
  'avhp.pg.kpiUnposted': 'Uposterte dokumenter i innboksen',
  'avhp.pg.hintUnposted': 'Inkluderer dokumenter som er lest, men ikke bokført — de telles ikke separat. Står som en egen oppgave i oppgavelista.',
  'avhp.pg.hintActiveTasks': 'En konkret aktivitet som skal løse en avstemmingspost. Et annet mål enn åpne poster.',
  'avhp.pg.progress': 'Arbeidsfremdrift: {pct} % behandlet',
  'avhp.pg.hideCalc': 'Skjul beregning',
  'avhp.pg.showCalc': 'Vis beregning',
  'avhp.pg.progressNote': 'Måler hvor mye som er gjennomgått — ikke hvor mye som er bestått. Et behandlet punkt kan fortsatt ha avvik.',
  'avhp.pg.readyYes': 'Klar for rapportering: Ja',
  'avhp.pg.readyNoOne': 'Klar for rapportering: Nei — {count} forhold står igjen',
  'avhp.pg.readyNoMany': 'Klar for rapportering: Nei — {count} forhold står igjen',
  'avhp.pg.finalStateNote': 'Beregnet sluttilstand — påvirkes ikke av at flere punkter er behandlet med avvik.',
  'avhp.pg.progressExplain': 'Arbeidsfremdriften er andelen av kontrollpunktene i den faglige sjekklista som er behandlet — {done} av {total}. De systemutledede punktene teller med når de har et svar; de faglige teller først når noen har tatt stilling til dem. Behandlede punkter med avvik teller med i fremdriften, men gjør ikke perioden klar for rapportering.',
  'avhp.pg.autoMasterControls': 'Automatisk avledede hovedkontroller',
  'avhp.pg.showPassedAuto': 'Vis {count} beståtte automatiske kontroller',
  'avhp.pg.areasNote': 'Status hentes fra hvert områdes egen avstemming — ingenting krysses av manuelt her. Klikk en rad for å åpne området.',
  'avhp.pg.scope': 'Omfang',
  'avhp.pg.materialBalance': 'Vesentlig saldo/avvik',
  'avhp.pg.openItems': 'Åpne poster',
  'avhp.pg.documentation': 'Dokumentasjon',
  'avhp.pg.lastUpdated': 'Sist oppdatert',
  'avhp.pg.openArea': 'Åpne {area}',
});
